(function () {
  "use strict";

  // Shopify's native "Forms" app renders <shopify-forms-embed> inside an OPEN
  // shadow root with no CSS custom properties or ::part() hooks exposed for
  // the fields/button it draws, so page/theme CSS can never reach in. Since
  // the root is open, we can append a stylesheet directly into it — this is
  // the only way to restyle this specific app embed. Covers the homepage
  // hero waitlist, the phases_waitlist section, and the Locksmith access gate.
  var STYLE_ATTR = "data-phases-forms-style";
  var HOST_SELECTOR = [
    '.index-hero form-embed',
    '.index-hero shopify-forms-embed',
    '[data-section-type="phases-waitlist"] form-embed',
    '[data-section-type="phases-waitlist"] shopify-forms-embed',
    '.phases-access-gate form-embed',
    '#locksmith-content form-embed',
  ].join(', ');

  var CSS = [
    '[class*="_formFieldContainer_"] { position: relative; }',
    // The app caps the inline form at ~450px via an internal container; open it up.
    '[data-sizing="form-wrapper"] {',
    "  max-width: 100% !important;",
    "  width: 100% !important;",
    "}",
    // First/last name side by side, phone + button each on their own full-width row.
    '[class*="_formFieldset_"] {',
    "  display: flex !important;",
    "  flex-direction: row !important;",
    "  flex-wrap: wrap !important;",
    "  align-items: flex-start !important;",
    "  column-gap: 0.75rem !important;",
    "  row-gap: 0.75rem !important;",
    "}",
    // Hidden fraud-detection element the app renders as the fieldset's first child;
    // left in flow it eats a gap and pushes the first field off centre.
    '[class*="_formFieldset_"] > div:has(shop-lead-capture) {',
    "  display: none !important;",
    "}",
    '[class*="_formFieldset_"] > [class*="_formFieldContainer_"] {',
    "  flex: 0 0 auto !important;",
    // Half the row minus half the gap (0.75rem), with a 1px safety margin so
    // subpixel rounding can't push the pair onto separate lines.
    "  width: calc(50% - 0.375rem - 1px) !important;",
    "  max-width: calc(50% - 0.375rem - 1px) !important;",
    "  min-width: 0 !important;",
    "  box-sizing: border-box !important;",
    "}",
    '[class*="_formFieldset_"] > [class*="_formPhoneInputContainer_"],',
    '[class*="_formFieldset_"] > [class*="_formSubmitButton_"] {',
    "  flex: 1 1 100% !important;",
    "  width: 100% !important;",
    "}",
    '[class*="_formInputField_"] {',
    "  box-sizing: border-box;",
    "  min-height: 3rem;",
    "  border-radius: 55px !important;",
    "  border: 1px solid #ffffff !important;",
    // The app draws its default field outline as a box-shadow, not a border;
    // clear it or a faint dark ring shows through around the white border.
    "  box-shadow: none !important;",
    "  background: transparent !important;",
    "  color: #ffffff !important;",
    // Left-align the actual typed text so the cursor lands on the left on
    // click, instead of jumping to the middle of the (empty) centered field.
    "  text-align: left !important;",
    "  padding-left: 1.25rem !important;",
    "  padding-right: 1.25rem !important;",
    "}",
    '[class*="_formInputFieldLabel_"] {',
    "  left: 1.25rem !important;",
    "  right: 1.25rem !important;",
    "  width: auto !important;",
    "  text-align: center !important;",
    "  color: rgba(255, 255, 255, 0.85) !important;",
    "  text-transform: uppercase !important;",
    "  letter-spacing: 0.05em !important;",
    "  pointer-events: none !important;",
    "}",
    '[class*="_formPhoneInputContainer_"] {',
    "  display: flex !important;",
    "  align-items: center !important;",
    "  gap: 0.5rem !important;",
    "  min-height: 3rem !important;",
    "  border: 1px solid #ffffff !important;",
    "  border-radius: 55px !important;",
    "  background: transparent !important;",
    "  padding-inline: 0.75rem !important;",
    "  box-sizing: border-box !important;",
    "}",
    '[class*="_formPhoneInputContainer_"] [class*="_formFieldContainer_"] {',
    "  flex: 1 1 auto !important;",
    "  min-width: 0 !important;",
    "}",
    '[class*="_formPhoneInputContainer_"] [class*="_formInputField_"],',
    '[class*="_formPhoneInputContainer_"] [class*="_formPhoneInputField_"] {',
    "  border: none !important;",
    "  box-shadow: none !important;",
    "  border-radius: 0 !important;",
    "  min-height: 0 !important;",
    "  color: #ffffff !important;",
    "  background: transparent !important;",
    "}",
    '[class*="_formPhoneInputContainer_"] [class*="_formInputFieldLabel_"] {',
    "  left: 2.25rem !important;",
    "  right: auto !important;",
    "  width: auto !important;",
    "  text-align: left !important;",
    "}",
    '[class*="_selectContainer_"],',
    '[class*="_selectToggle_"] {',
    "  border: none !important;",
    "  border-radius: 0 !important;",
    "  background: transparent !important;",
    "  box-shadow: none !important;",
    "}",
    '[class*="_formSubmitButton_"] {',
    "  display: flex !important;",
    "  align-items: center !important;",
    "  justify-content: center !important;",
    "  box-sizing: border-box !important;",
    "  width: 100% !important;",
    "  height: 3rem !important;",
    "  padding: 0 1.75rem !important;",
    "  border-radius: 55px !important;",
    "  border: 1px solid #ffffff !important;",
    "  background: #ffffff !important;",
    "  color: #212121 !important;",
    "  text-transform: uppercase !important;",
    "  letter-spacing: 0.05em !important;",
    "}",
    "@media (hover: hover) {",
    '  [class*="_formSubmitButton_"]:hover {',
    "    background: #212121 !important;",
    "    border-color: #212121 !important;",
    "    color: #ffffff !important;",
    "  }",
    "}",
  ].join("\n");

  var GATE_CSS = [
    '[class*="_formFieldContainer_"] { position: relative; }',
    '[data-sizing="form-wrapper"] {',
    "  max-width: 100% !important;",
    "  width: 100% !important;",
    "}",
    '[class*="_formFieldset_"] {',
    "  display: flex !important;",
    "  flex-direction: row !important;",
    "  flex-wrap: wrap !important;",
    "  align-items: flex-start !important;",
    "  column-gap: 0.75rem !important;",
    "  row-gap: 0.75rem !important;",
    "}",
    '[class*="_formFieldset_"] > div:has(shop-lead-capture) {',
    "  display: none !important;",
    "}",
    '[class*="_formFieldset_"] > [class*="_formFieldContainer_"] {',
    "  flex: 0 0 auto !important;",
    "  width: calc(50% - 0.375rem - 1px) !important;",
    "  max-width: calc(50% - 0.375rem - 1px) !important;",
    "  min-width: 0 !important;",
    "  box-sizing: border-box !important;",
    "}",
    '[class*="_formFieldset_"] > [class*="_formPhoneInputContainer_"],',
    '[class*="_formFieldset_"] > [class*="_formSubmitButton_"] {',
    "  flex: 1 1 100% !important;",
    "  width: 100% !important;",
    "}",
    '[class*="_formInputField_"] {',
    "  box-sizing: border-box;",
    "  min-height: 3rem;",
    "  border-radius: 55px !important;",
    "  border: 1px solid #222222 !important;",
    "  box-shadow: none !important;",
    "  background: transparent !important;",
    "  color: #222222 !important;",
    "  text-align: left !important;",
    "  padding-left: 1.25rem !important;",
    "  padding-right: 1.25rem !important;",
    "}",
    '[class*="_formInputFieldLabel_"] {',
    "  left: 1.25rem !important;",
    "  right: 1.25rem !important;",
    "  width: auto !important;",
    "  text-align: center !important;",
    "  color: rgba(34, 34, 34, 0.55) !important;",
    "  text-transform: uppercase !important;",
    "  letter-spacing: 0.05em !important;",
    "  pointer-events: none !important;",
    "}",
    '[class*="_formPhoneInputContainer_"] {',
    "  display: flex !important;",
    "  align-items: center !important;",
    "  gap: 0.5rem !important;",
    "  min-height: 3rem !important;",
    "  border: 1px solid #222222 !important;",
    "  border-radius: 55px !important;",
    "  background: transparent !important;",
    "  padding-inline: 0.75rem !important;",
    "  box-sizing: border-box !important;",
    "}",
    '[class*="_formPhoneInputContainer_"] [class*="_formFieldContainer_"] {',
    "  flex: 1 1 auto !important;",
    "  min-width: 0 !important;",
    "}",
    '[class*="_formPhoneInputContainer_"] [class*="_formInputField_"],',
    '[class*="_formPhoneInputContainer_"] [class*="_formPhoneInputField_"] {',
    "  border: none !important;",
    "  box-shadow: none !important;",
    "  border-radius: 0 !important;",
    "  min-height: 0 !important;",
    "  color: #222222 !important;",
    "  background: transparent !important;",
    "}",
    '[class*="_formPhoneInputContainer_"] [class*="_formInputFieldLabel_"] {',
    "  left: 2.25rem !important;",
    "  right: auto !important;",
    "  width: auto !important;",
    "  text-align: left !important;",
    "}",
    '[class*="_selectContainer_"],',
    '[class*="_selectToggle_"] {',
    "  border: none !important;",
    "  border-radius: 0 !important;",
    "  background: transparent !important;",
    "  box-shadow: none !important;",
    "}",
    '[class*="_formSubmitButton_"] {',
    "  display: flex !important;",
    "  align-items: center !important;",
    "  justify-content: center !important;",
    "  box-sizing: border-box !important;",
    "  width: 100% !important;",
    "  height: 3rem !important;",
    "  padding: 0 1.75rem !important;",
    "  border-radius: 55px !important;",
    "  border: 1px solid #222222 !important;",
    "  background: #222222 !important;",
    "  color: #ffffff !important;",
    "  text-transform: uppercase !important;",
    "  letter-spacing: 0.05em !important;",
    "}",
    "@media (hover: hover) {",
    '  [class*="_formSubmitButton_"]:hover {',
    "    background: #ffffff !important;",
    "    border-color: #222222 !important;",
    "    color: #222222 !important;",
    "  }",
    "}",
  ].join("\n");

  function isGateEmbed(embed) {
    return !!(embed.closest && embed.closest(".phases-access-gate, #locksmith-content"));
  }

  function styleEmbed(embed) {
    var root = embed.shadowRoot;
    if (!root) return false;
    if (!root.querySelector("input, button, form, [class*='_form']")) return false;
    if (!root.querySelector("style[" + STYLE_ATTR + "]")) {
      var style = document.createElement("style");
      style.setAttribute(STYLE_ATTR, "");
      style.textContent = isGateEmbed(embed) ? GATE_CSS : CSS;
      root.appendChild(style);
    }
    return true;
  }

  function styleAll() {
    var embeds = document.querySelectorAll(HOST_SELECTOR);
    if (!embeds.length) return false;
    var allStyled = true;
    embeds.forEach(function (embed) {
      if (!styleEmbed(embed)) allStyled = false;
    });
    return allStyled;
  }

  styleAll();

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("form-embed").then(styleAll).catch(function () {});
    customElements
      .whenDefined("shopify-forms-embed")
      .then(styleAll)
      .catch(function () {});
  }

  // Fallback: the shadow root can attach a tick after the element upgrades.
  // Locksmith may also inject the gate after first paint.
  var attempts = 0;
  var retry = setInterval(function () {
    attempts += 1;
    if (styleAll() || attempts >= 80) clearInterval(retry);
  }, 250);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      styleAll();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
